import { jsxs, jsx, Fragment } from '@emotion/react/jsx-runtime';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import { styled } from '@mui/material/styles';
import { usePopupState, bindTrigger, bindPopover } from 'material-ui-popup-state/hooks';

const classPrefix = 'fsn-popover-header-action';
const classes = {
    root: `${classPrefix}-root`,
    content: `${classPrefix}-content`,
};
const ids = {
    ...classes,
    button: `${classPrefix}-button`,
};
const PopoverContent = styled('div')(({ theme }) => ({
    [`&.${classes.content}`]: {
        padding: theme.spacing(2),
    },
}));
/**
 * The Popover Header Action component provides a generic skeleton of a popover-style header action.  It includes an
 * icon button for the header, which launches a popover to contain your content. The component should be nested under
 * the `FsnHeader`.
 */
const FsnPopoverHeaderAction = ({ ariaLabel = 'Header Action', icon, children = jsx(Fragment, {}), }) => {
    const popupState = usePopupState({
        variant: 'popover',
        popupId: 'fsnHeaderActionPopover',
    });
    return (jsxs("div", { "data-testid": ids.root, children: [jsx(IconButton, { ...bindTrigger(popupState), "data-testid": ids.button, color: "inherit", "aria-label": ariaLabel, children: icon }), jsx(Popover, { ...bindPopover(popupState), anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }, children: jsx(PopoverContent, { className: classes.content, children: children }) })] }));
};

export { FsnPopoverHeaderAction, ids as testIds };
